// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"9796":"45de5d6eda7c3725","9892":"44a5a78b085ded53"}[chunkId] + ".css";
};